import { motion } from "framer-motion";
// Import your local images from the assets folder:
import img2021 from "@/assets/2021.jpg";
import img2020 from "@/assets/2020.jpg";
import img2023 from "@/assets/2023.jpg";
// import img2024 from "@/assets/2024.jpg";
import img2026_1 from "@/assets/2026_1.jpg";
import img2026_2 from "@/assets/2026_2.jpg";

const milestones = [
  {
    year: "2020",
    title: "The eventful spark",
    line: "Bonding over books. Random talks, two strangers, on a road less travelled.",
    image: img2020,
  },
  {
    year: "2021",
    title: "The phone-call year",
    line: "The missed auto rides.",
    image: img2021,
  },
  {
    year: "2023",
    title: "Growing together",
    line: "Bengaluru was kind to us.",
    image: img2023,
  },
  {
    year: "2026",
    title: "An evening to remember",
    line: "A beautiful sunset. Varsha graduates from ISB.",
    image:img2026_1,
  },
  {
    year: "2026",
    title: "Forever begins",
    line: "Blessings from family and friends.",
    image: img2026_2,
  },
];

export default function StoryPage() {
  return (
    <div data-testid="story-page">
      {/* Page header */}
      <section
        className="border-b"
        style={{ background: "#FBF5EA", borderColor: "#EFE6D2" }}
      >
        <div className="max-w-5xl mx-auto px-5 sm:px-12 py-20 sm:py-28 text-center">
          <p className="overline">
            <span className="divider-line mr-4" />
            Our Story
            <span className="divider-line ml-4" />
          </p>
          <h1 className="font-serif-wb mt-7 text-4xl sm:text-5xl lg:text-7xl tracking-tighter">
            A love story{" "}
            <span className="italic" style={{ color: "var(--wb-primary)" }}>
              in chapters.
            </span>
          </h1>
          <p
            className="mt-7 max-w-xl mx-auto text-sm sm:text-base leading-relaxed"
            style={{ color: "var(--wb-text-muted)" }}
          >
            Five moments — small enough to fit in a frame, big enough to bring
            us here.
          </p>
        </div>
      </section>

      {/* Timeline */}
      <section className="max-w-5xl mx-auto px-5 sm:px-12 py-20 md:py-28">
        <div className="relative">
          {/* Vertical line */}
          <div
            aria-hidden
            className="absolute top-0 bottom-0 left-4 sm:left-1/2 sm:-translate-x-1/2 w-px"
            style={{ background: "#EFE6D2" }}
          />

          <ol className="space-y-14 sm:space-y-20">
            {milestones.map((m, i) => {
              const isRight = i % 2 === 1;
              return (
                <motion.li
                  key={m.year}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.25 }}
                  transition={{ duration: 0.8 }}
                  data-testid={`story-milestone-${i}`}
                  className="relative"
                >
                  {/* Dot */}
                  <span
                    aria-hidden
                    className="absolute left-4 sm:left-1/2 -translate-x-1/2 top-3 w-3 h-3 rounded-full ring-4 ring-[#FBF5EA]"
                    style={{ background: "var(--wb-primary)" }}
                  />

                  <div
                    className={`pl-12 sm:pl-0 sm:grid sm:grid-cols-2 sm:gap-12 items-center ${
                      isRight ? "" : ""
                    }`}
                  >
                    {/* Image (alternates side on sm+) */}
                    <div
                      className={`mb-5 sm:mb-0 ${
                        isRight ? "sm:order-2 sm:pl-10" : "sm:order-1 sm:pr-10 sm:text-right"
                      }`}
                    >
                      <div className="overflow-hidden border border-[#EFE6D2] aspect-[5/4] max-w-md sm:ml-auto sm:mr-0">
                        <img
                          src={m.image}
                          alt={m.title}
                          className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1200ms]"
                          style={{
                            objectPosition:
                              m.image === img2026_1 || m.image === img2026_2
                                ? "center center"
                                : "center top",
                          }}
                          loading="lazy"
                        />
                      </div>
                    </div>

                    {/* Copy */}
                    <div
                      className={`${
                        isRight ? "sm:order-1 sm:pr-10 sm:text-right" : "sm:order-2 sm:pl-10"
                      }`}
                    >
                      <p
                        className="font-serif-wb italic text-4xl sm:text-5xl"
                        style={{ color: "var(--wb-primary)" }}
                      >
                        {m.year}
                      </p>
                      <h3 className="font-serif-wb text-2xl sm:text-3xl mt-2 tracking-tight">
                        {m.title}
                      </h3>
                      <p
                        className="mt-3 text-sm sm:text-base leading-relaxed"
                        style={{ color: "var(--wb-text-muted)" }}
                      >
                        {m.line}
                      </p>
                    </div>
                  </div>
                </motion.li>
              );
            })}
          </ol>
        </div>
      </section>
    </div>
  );
}
